module.exports = __webpack_public_path__ + "img/example-qr.950bab96.svg";